FormLikeField = ({ label = '', children = [] }) ->
  <div style={{ marginBottom: 24 }}>
    <span style={{ marginBottom: 5, display: 'block' }}>{ label }</span>
    { children }
  </div>

export default FormLikeField